import React, { useContext } from 'react';
import { Table, Tag, Tooltip } from 'antd';
import { sparkToast } from '@spark';
import { colors } from '@/shared/tokens/colors';
import { CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined, RocketOutlined, StopOutlined } from '@ant-design/icons';
import { data_from_server_post } from '@/shared/http/client';
import { GlobalContext } from '@/app/providers/globalState';
import { deploy_in_progress, deployed, distillation_in_progress, evaluation_in_progress, gathering_data, ready_for_distillation, ready_to_deploy, undeploy_in_progress, waiting_for_data, waiting_for_prompt_and_teacher } from '@/shared/constants/taskStatuses';
import { formatDateTime } from '@/shared/utils/helpers';
const checkCircleStyle = { color: colors.green, fontSize: '16px' }
const closeCircleStyle = { color: colors.red, fontSize: '16px' }


function getColumns(moveToScreen, updateStatus) {
    return [
        {
            title: 'Application Name',
            dataIndex: 'group_name',
            render: (value, record) => (
                <div onClick={() => moveToUsecase(record, moveToScreen)}>{value}</div>
            ),
        },
        {
            title: 'Usecase Name',
            dataIndex: 'usecase_name',
            render: (value, record) => (
                <div onClick={() => moveToUsecase(record, moveToScreen)}>{value}</div>
            ),
        },
        {
            title: 'Version',
            dataIndex: 'version',
            width: "80px",
            render: (value, record) => (
                <div onClick={() => moveToUsecase(record, moveToScreen)}>V{value}.0</div>
            ),
        },
        {
            title: 'Created At',
            dataIndex: 'created_datetime',
            width: "300px",
            render: (value, _) => formatDateTime(value),
        },
        // {
        //     title: 'Updated',
        //     dataIndex: 'last_update_time',
        //     width: "300px",
        //     render: (value, _) => formatDateTime(value),
        // },
        {
            title: 'Status',
            dataIndex: 'status',
            width: "300px",
            render: (value, _) => renderStatus(value),
        },
        {
            title: 'Deployed',
            dataIndex: 'is_deployed',
            width: "105px",
            render: (value, record) => renderIsDeployed(value, record),
        },
        {
            title: '',
            dataIndex: 'actions',
            width: "1%",
            render: (_, record) => {
                return <div>
                    {(record.status === deploy_in_progress || record.status === undeploy_in_progress)
                        && <Tooltip title={`Deploying V${record.version}.0 is in Progress`}>
                            <LoadingOutlined style={{ color: colors.buttonsBlue }} />
                        </Tooltip>}
                    {record.status === ready_to_deploy && <Tooltip title={`Deploy version V${record.version}.0`}>
                        <RocketOutlined style={{ color: colors.buttonsBlue }} onClick={() => modelDeployment(record, "deploy", updateStatus)} />
                    </Tooltip>}
                    {record.is_deployed && record.status !== deploy_in_progress && <Tooltip title={`Undeploy version V${record.deployed_version}.0`}>
                        <StopOutlined style={{ color: colors.buttonsBlue }} onClick={() => modelDeployment(record, "undeploy", updateStatus)} />
                    </Tooltip>}
                </div>
            },
            //Start Prototyping
            //Deploy -> 
        },
    ]
}


function modelDeployment(record, action, updateStatus) {
    updateStatus(record._id, action == "deploy" ? deploy_in_progress : undeploy_in_progress)
    data_from_server_post(
        "model-deployment",
        {
            client_id: record.client_id,
            llm_usecase_id: record._id,
            task_type: record.task_type,
            request_type: action,
            deployed_version: record.deployed_version,
        },
        (result) => {
            if (result.success) {
                sparkToast.success(`${action} in progress`);
                // Refresh usecases to get updated status from server
                setTimeout(updateStatus, 2000);
            } else {
                sparkToast.error(`Failed to ${action} model`);
                updateStatus(record._id, action == "deploy" ? deploy_in_progress : undeploy_in_progress)
            }
        }
    );
}

function moveToUsecase(record, moveToScreen) {
    moveToScreen(record._id, "playground")
}


export function renderIsDeployed(is_deployed, record) {
    return is_deployed ? <div><CheckCircleOutlined style={{ ...checkCircleStyle, ...{ marginRight: "2px" } }} /> <span>(V{record?.deployed_version}.0)</span></div>
        : <CloseCircleOutlined style={closeCircleStyle} />
}

export function getColorForUsecaseStatus(status, colorForTag = false) {
    let color = colorForTag ? "gray" : colors.gray;
    if (status === waiting_for_prompt_and_teacher) {
        color = colorForTag ? "red" : colors.red;
    } else if (status === waiting_for_data) {
        color = colorForTag ? "orange" : colors.orange;
    } else if (status === gathering_data) {
        color = colorForTag ? "yellow" : colors.yellow;
    } else if (status === ready_for_distillation) {
        color = colorForTag ? "purple" : colors.purple;
    } else if (status === distillation_in_progress) {
        color = colorForTag ? "blue" : colors.buttonsBlue;
    } else if (status === evaluation_in_progress) {
        color = colorForTag ? "cyan" : colors.cyan;
    } else if (status === ready_to_deploy) {
        color = colorForTag ? "green" : colors.green; //TODO: decide on colors
    } else if (status === deploy_in_progress) {
        color = colorForTag ? "orange" : colors.orange;  //TODO: decide on colors
    } else if (status === deployed) {
        color = colorForTag ? "green" : colors.green;
    } else if (status === undeploy_in_progress) {
        color = colorForTag ? "orange" : colors.orange; //TODO: decide on colors
    }
    return color;
}

function renderStatus(status) {
    const color = getColorForUsecaseStatus(status);
    return <Tag color={color}>{status}</Tag>
}

export const HomepageTableView = ({ usecases, moveToScreen }) => {
    const {
        updateStatus,
    } = useContext(GlobalContext);

    return (
        <Table
            columns={getColumns(moveToScreen, updateStatus)}
            dataSource={usecases.map(usecase => ({
                ...usecase,
                key: usecase._id
            }))}
        />
    );
};